/**
 * Converts talent purity (0-9) to stat bonus percentage (0%-100%)
 * @param purity - The purity level (0-9)
 * @returns The stat bonus percentage (0%-100%)
 */
export const purityToStatBonus = (purity: number): number => {
  // Purity 0 should give 0% bonus
  if (purity <= 0) return 0;

  // Clamp purity between 1 and 9
  const clampedPurity = Math.min(9, purity);

  // Linear interpolation from 1->5% to 9->100%
  // Formula: percentage = 5 + ((purity - 1) * (100 - 5)) / (9 - 1)
  return 5 + ((clampedPurity - 1) * 95) / 8;
};

/**
 * Calculates the purity of a pokemon based on its talents and types
 * Purity = number of talents that match the pokemon's types
 * @param talents - Array of talent strings (pokemon types)
 * @param pokemonTypes - Array of pokemon type strings
 * @returns The purity level (0-9, but typically 0-2 for single type, 0-4 for dual type)
 */
export const calculatePurity = (talents: string[], pokemonTypes: string[]): number => {
  const normalizedTypes = pokemonTypes.map(type => type.toLowerCase());
  const matchingTalents = talents.filter(talent =>
    normalizedTypes.includes(talent.toLowerCase())
  );

  return matchingTalents.length;
};
